<div class="w-full relative" (mouseleave)="isVisibleListCnpjs.set(false)">
    <input [(ngModel)]="selectedCnpj" (click)="toggleInputCnpj()" (ngModelChange)="onFilterCnpj()"
        [disabled]="isLoading()" id="cnpj" type="text" mask="00.000.000/0000-00"
        [ngClass]="{'ps-11': isLoading(), 'bg-white': isBackgroundWhite, 'bg-gray-100': !isBackgroundWhite}"
        class="w-full p-4 px-5 text-base sm:text-sm rounded-lg font-semibold text-gray-600 border-none focus:ring-0 pe-12 disabled:bg-gray-200"
        autocomplete="off" placeholder="00.000.000/0000-00">

    @if (isLoading()) {
    <div class="absolute inset-y-0 start-0 flex items-center pointer-events-none ps-4">
        <div class="animate-spin inline-block size-4 border-[3px] border-current border-t-transparent text-blue-600 rounded-full"
            role="status" aria-label="loading">
            <span class="sr-only">Loading...</span>
        </div>
    </div>
    }

    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"
        class="absolute right-5 top-1/2 transform -translate-y-1/2 size-6 text-gray-500">
        <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 15 12 18.75 15.75 15m-7.5-6L12 5.25 15.75 9" />
    </svg>

    @if (!isLoading() && isVisibleListCnpjs()) {
    <div
        class="shadow-xl absolute p-1 border border-gray-200 h-auto rounded-md z-40 w-full max-h-52 bg-white overflow-auto scrollbar-thin scrollbar-thumb-black scrollbar-track-transparent animate-fade-down animate-duration-200 animate-ease-out">
        <div class="px-3">
            <span class="text-xs font-semibold text-neutral-500">
                Confira abaixo todos os CNPJs aos quais você tem acesso.
            </span>
        </div>

        <ul class="space-y-1 py-2">
            @for (cnpj of filteredCnpjs(); track $index) {
            <li (click)="onSelectCnpj(cnpj.cnpj)"
                class="group flex flex-col space-y-1 py-2 px-3 hover:bg-gray-100 rounded-md cursor-pointer">
                <span
                    class="text-base sm:text-sm font-semibold group-hover:text-blue-500 transition-colors duration-300 ease-in-out">
                    {{ cnpj.cnpj | formatCnpj }}
                </span>
                <span
                    class="text-sm sm:text-xs font-medium text-neutral-500 group-hover:text-blue-500 transition-colors duration-300 ease-in-out">
                    {{ cnpj.nome_licenciado }}
                </span>
            </li>
            } @empty {
            <li class="flex flex-col space-y-1 py-2 px-3 rounded-md cursor-pointer">
                <span class="text-base sm:text-sm font-semibold">
                    Nenhum CNPJ encontrado.
                </span>
            </li>
            }
        </ul>
    </div>
    }
</div>